import { route, string } from 'react-router-typesafe-routes/dom'
/**
 * Shared "company shell" typed route — matches the common `:companyId`
 * segment that every /et module route declares as its outer param.
 *
 * Use `useTypedParams(COMPANY_ROUTE)` in a module entry component to get
 * `{ companyId: number }` without hand-writing a `useParams<{ companyId: string }>()`
 * generic per file. `useTypedParams` doesn't enforce that the current URL
 * matches this exact pattern — it just parses whatever params the router
 * exposes, which always includes `:companyId` inside an /et module tree.
 */
export const COMPANY_ROUTE = route('et/company/:companyId', {
  params: { companyId: string().defined() },
})

/**
 * Shared URL-param codecs for the `/et` routes. Keep format validators in one
 * place so every module agrees on what a date/month/year segment looks like.
 */

// `YYYY-MM-DD` — matches app-wide `SERVICE_DATE_FORMAT`.
export const dateString = string((v) => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(v)) {
    throw new Error(`Expected YYYY-MM-DD, got "${v}"`)
  }
  return v
})

// `YYYY-MM`.
export const monthString = string((v) => {
  if (!/^\d{4}-\d{2}$/.test(v)) {
    throw new Error(`Expected YYYY-MM, got "${v}"`)
  }
  return v
})
